import ReferentielFormController from './referentiel.form.controller';

export default {
    template: require('./referentiel.form.html'),
    controller: ReferentielFormController
};
